import * as XLSX from 'xlsx';

type GenericElements = {
  [key: string]: string | number | null | undefined
};

type CreateXlsxOptions = {
  currencyColumns?: string[];
  textColumns?: string[];
  columnWidths?: { [columnName: string]: number };
  titleRow?: string;
};

export const createXLSXFile = (
  elements: Array<GenericElements>,
  fileName: string,
  options: CreateXlsxOptions = {}
) => {
  const book = XLSX.utils.book_new();

  let paper: any;
  let headerRowIndex = 0;

  // If titleRow is provided, we need to add it manually
  if (options.titleRow) {
    // Create sheet with title row first
    paper = XLSX.utils.aoa_to_sheet([[options.titleRow]]);
    headerRowIndex = 1;

    // Add data starting from row 2 (index 1)
    XLSX.utils.sheet_add_json(paper, elements, { origin: 'A2', skipHeader: false });

    // Merge cells for title row (A1 to last column)
    if (elements.length > 0) {
      const headers = Object.keys(elements[0]);
      const lastColumn = XLSX.utils.encode_col(headers.length - 1);
      paper['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];

      // Style the title row
      paper['A1'].s = {
        font: { bold: true, sz: 14 },
        alignment: { horizontal: 'left', vertical: 'center' }
      };
    }
  } else {
    paper = XLSX.utils.json_to_sheet(elements);
  }

  if (elements.length > 0) {
    const headers = Object.keys(elements[0]);

    // Set column widths
    paper["!cols"] = headers.map((header) => {
      // Check if custom width is defined for this column
      if (options.columnWidths && options.columnWidths[header]) {
        return { wch: options.columnWidths[header] };
      }
      // Default width calculation
      return { wch: header.length + 2 };
    });

    // Style header row
    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (paper[cellAddress]) {
        paper[cellAddress].s = {
          font: { bold: true },
        };
      }
    });
    // Forzar tipo string en columnas de texto para evitar que SheetJS reinterprete fechas
    if (options.textColumns?.length) {
      const textColumnIndexes = headers.reduce<number[]>((acc, header, index) => {
        if (options.textColumns?.includes(header)) acc.push(index);
        return acc;
      }, []);

      elements.forEach((_, rowIndex) => {
        textColumnIndexes.forEach((columnIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1 + headerRowIndex, c: columnIndex });
          const cell = paper[cellAddress];
          if (cell) {
            cell.t = 's';
            cell.v = String(cell.v ?? '');
          }
        });
      });
    }

    //Si la columna esta en options se formatea como moneda
    if (options.currencyColumns?.length) {
      const currencyColumnIndexes = headers.reduce<number[]>((acc, header, index) => {
        if (options.currencyColumns?.includes(header)) {
          acc.push(index);
        }
        return acc;
      }, []);

      elements.forEach((_, rowIndex) => {
        currencyColumnIndexes.forEach((columnIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1 + headerRowIndex, c: columnIndex });
          const cell = paper[cellAddress];
          if (cell && typeof cell.v === "number") {
            cell.t = 'n';
            cell.z = '$#,##0.00';
          }
        });
      });
    }
  }

  XLSX.utils.book_append_sheet(book, paper, fileName);

  setTimeout(() => {
    XLSX.writeFile(book, `${fileName}.xlsx`);
  }, 1000);
};